/** Platform-only preview features (Apps hub, email inbox, etc.) */
export const PLATFORM_TEST_EMAIL = 'platformtest@idotoo.ai';

export function canAccessPlatformPreviewFeatures(user) {
  const userEmail = String(user?.email || '').trim().toLowerCase();
  return user?.role === 'admin' || userEmail === PLATFORM_TEST_EMAIL;
}
